import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { AzureSynapseArtifactsLinkedService, azureSynapseArtifactsAuthTypes, CredentialTypeOptions } from 'shell-models-lib';
import { azureResourceSelectMethodOptions } from 'app/registries/consts/metadata-consts';
import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';
import { GlobalVariables } from 'app/services/globals';

const workspaceSelectionSetting: ControlMetadata = {
    type: 'radio-switch',
    nested: 1,
    label: stringResources.AzureSynapseArtifacts_Workspace_SelectionMethod,
    description: stringResources.AzureSynapseArtifacts_Workspace_SelectMethodDescription,
    options: azureResourceSelectMethodOptions,
    defaultValue: '{endpoint != null || parameterized ? "manual" : "azure"}',
    isLabelVertical: true,
    cases: [
        {
            caseValue: 'azure',
            children: [
                {
                    type: 'azure-synapse-workspace-select',
                    bind: {
                        endpoint: 'endpoint',
                        workspaceResourceId: 'workspaceResourceId'
                    },
                    validators: {
                        endpoint: [
                            { type: 'required', errorMessage: '' }
                        ],
                    }
                }
            ]
        },
        {
            caseValue: 'manual',
            children: [
                {
                    type: 'parameterizable',
                    child: {
                        type: 'textbox',
                        bind: 'endpoint',
                        label: stringResources.ModelName_SynapseWorkspaceEndpoint,
                        description: stringResources.SynapseWorkspaceURLDescription,
                        required: true,
                        validators: [
                            { type: 'required', errorMessage: '' }
                        ],
                        isLabelVertical: true
                    }
                },
                {
                    type: 'parameterizable',
                    child: {
                        type: 'textbox',
                        bind: 'workspaceResourceId',
                        label: stringResources.ModelName_WorkspaceResourceId,
                        description: stringResources.SynapseWorkspaceIdDescription,
                        isLabelVertical: true
                    }
                }
            ]
        }
    ]
};

export const azureSynapseArtifactsMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(AzureSynapseArtifactsLinkedService).name,
    category: ['Compute'],
    displayName: stringResources.AzureSynapseAnalyticsArtifacts,
    icon: {
        className: 'svg-i-100x100-AzureSynapse'
    },
    isOnPremises: false,
    isCompute: true,
    isFirstClass: true,
    onlyAzureIR: true,
    supportFirstClassParameterExperience: true,
    supportPE: true,
    peGroupIDs: ['dev'],
    controls: [
        {
            type: 'select-switch',
            bind: 'authenticationMethod',
            label: stringResources.Authentication_Method_Label,
            options: [
                {
                    label: stringResources.AuthenticationType_ManagedServiceIdentity,
                    value: azureSynapseArtifactsAuthTypes.MSIAuthentication
                },
                {
                    label: stringResources.AuthenticationType_UserAssignedManagedIdentity,
                    value: azureSynapseArtifactsAuthTypes.UserAssignedManagedIdentity,
                    hidden: !GlobalVariables.enableSynapseLinkedServiceUami
                }
            ],
            isLabelVertical: true,
            defaultValue: azureSynapseArtifactsAuthTypes.MSIAuthentication,
            cases: [
                {
                    caseValue: azureSynapseArtifactsAuthTypes.MSIAuthentication,
                    children: [
                        workspaceSelectionSetting,
                        {
                            type: 'management-identity-info',
                            resourceType: stringResources.AzureSynapseAnalyticsArtifacts,
                            link: 'https://docs.microsoft.com/azure/synapse-analytics/security/how-to-manage-synapse-rbac-role-assignments'
                        }
                    ]
                },
                {
                    caseValue: azureSynapseArtifactsAuthTypes.UserAssignedManagedIdentity,
                    children: [
                        {
                            type: 'credential-select',
                            bind: 'credential',
                            filterCredentialType: CredentialTypeOptions.UserAssignedManagedIdentity,
                            required: true,
                            validators: [
                                { type: 'required', errorMessage: '' }
                            ]
                        },
                        workspaceSelectionSetting
                    ]
                }
            ]
        }
    ],
    copySinkTypes: [],
    copySourceTypes: []
};
